import { createStore, applyMiddleware } from 'redux';
import { hashHistory } from 'react-router';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import reducers from './reducers/index';

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const persistedState = typeof localStorage === 'undefined' ? {} :
// (localStorage.getItem('SweetinnWeb') ? JSON.parse(localStorage.getItem('SweetinnWeb')) : {});

const store = createStore(reducers, applyMiddleware(thunk, logger()));

// store.subscribe(() => {
//   const state = store.getState();
//   localStorage.setItem('SweetinnWeb', JSON.stringify({ auth: state.auth }));
// });

export const history = hashHistory;

export default store;



// WEBPACK FOOTER //
// ./src/Store.js